import 'scss/services/textRecg.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import { goServiceBuy } from 'js/libs/utils-services-buy'
import { config } from 'config'

$(function () {
  $('.answer-table .buy-btn').click(function () {
    let packageId = $(this).data('packageId')
    let params = {
      wareId: '1102',
      packageId: packageId,
      serviceName: '印刷文字识别',
      businessId: 'general'
    }
    goServiceBuy(params)
  })
  serviceQA()
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/textRecg.js